export function createTasksApi(http) {
  return {
    list: (params = {}) => http.get("/zadania", { params }),
    getTaskId: (params = {}) => http.get("/zadania/getTaskId", { params }),
    active: () => http.get("/zadania/aktywneTaski"),
    mine: (params = {}) => http.get("/zadania/mojeTaski", { params }),
    allReports: (params = {}) => http.get("/zadania/wszystkieRaporty", { params }),
    search: (data) => http.post("/zadania/search", data),
    find: (taskId) => http.get(`/zadania/${taskId}`),
    create: (data) => http.post("/zadania", data),
    update: (taskId, data) => http.put(`/zadania/${taskId}`, data),
    remove: (taskId) => http.delete(`/zadania/${taskId}`),
    completeTrayWashing: (taskId, data) =>
      http.post(`/zadania/${taskId}/mycie-foremek`, data),
    addLoadingInfo: (taskId, data) =>
      http.post(`/zadania/${taskId}/addZaladunekInfo`, data),
    updateLoadingInfo: (loadingId, data) =>
      http.post(`/zadania/zaladunki-lv-w-chlodni/update/${loadingId}`, data),
    addInfo: (taskId, data) =>
      http.post(`/zadania/${taskId}/add-info`, data),
    addPouringInfo: (taskId, data) =>
      http.post(`/zadania/${taskId}/addRozlewInfo`, data),
    deleteShift: (taskId, shiftNumber, expectedVersion) =>
      http.delete(`/zadania/${taskId}/shift/${shiftNumber}`, {
        data: { expected_version: expectedVersion },
      }),
  };
}
